export default "__VITE_ASSET__BS8o13Ci__"